require('./bootstrap');
require('./inline-edit');
